import { useEffect, useState } from "react";
import { Carousel, CarouselContent, CarouselItem, CarouselPrevious, CarouselNext } from "@/components/ui/carousel";
import { Quote, Star } from "lucide-react";
import { TESTIMONIALS } from "@/data/catalog";

const Stars = ({ rating }) => (
  <div className="flex gap-0.5">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${i < rating ? "text-[#D4AF37] fill-[#D4AF37]" : "text-[#E5E0D8]"}`}
      />
    ))}
  </div>
);

export const Testimonials = () => {
  const [api, setApi] = useState(null);

  useEffect(() => {
    if (!api) return;
    const timer = setInterval(() => api.scrollNext(), 4000);
    return () => clearInterval(timer);
  }, [api]);

  return (
    <section data-testid="testimonials-section" id="reviews" className="py-16 sm:py-24 bg-[#F9F6F0]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <p className="text-xs uppercase tracking-[0.25em] font-semibold text-[#C05C46] mb-3">
            Customer Stories
          </p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#1c2826] mb-4">
            Loved Across India
          </h2>
          <p className="text-base text-[#4B5563] leading-relaxed">
            Real experiences from customers using Eleven Stars Ayurvedic supplements every day.
          </p>
        </div>

        <Carousel setApi={setApi} opts={{ loop: true, align: "start" }} className="w-full">
          <CarouselContent className="-ml-4">
            {TESTIMONIALS.map((t, i) => (
              <CarouselItem key={i} className="pl-4 md:basis-1/2 lg:basis-1/3">
                <div
                  data-testid={`testimonial-${i}`}
                  className="bg-white rounded-xl border border-[#E5E0D8] p-6 shadow-sm h-full flex flex-col"
                >
                  <Quote className="w-7 h-7 text-[#7C9A82] mb-4" />
                  <p className="text-sm text-[#4B5563] leading-relaxed flex-1">"{t.text}"</p>
                  <div className="mt-5 pt-4 border-t border-[#E5E0D8] flex items-center justify-between">
                    <div>
                      <p className="font-semibold text-[#1c2826] text-sm">{t.name}</p>
                      <p className="text-xs text-[#4B5563]">
                        {t.city} · {t.product}
                      </p>
                    </div>
                    <Stars rating={t.rating} />
                  </div>
                </div>
              </CarouselItem>
            ))}
          </CarouselContent>
          <div className="flex justify-end gap-2 mt-6">
            <CarouselPrevious
              data-testid="testimonials-prev"
              className="static translate-y-0 border-[#1A4331]/30 text-[#1A4331] hover:bg-[#1A4331] hover:text-white"
            />
            <CarouselNext
              data-testid="testimonials-next"
              className="static translate-y-0 border-[#1A4331]/30 text-[#1A4331] hover:bg-[#1A4331] hover:text-white"
            />
          </div>
        </Carousel>
      </div>
    </section>
  );
};
